import styled from 'styled-components'
import { colors } from '../../../../../styles/constants'

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.125rem;
  padding: 1rem;
  border-radius: .75rem;
  background-color: ${({ hasBackground, color }) => hasBackground ? (color ?? colors.white) : colors.transparent};
  flex: 1;
  img {
    align-self: flex-start;
  }
`

export const Message = styled.p`
  font-family: 'Open Sans';
  font-size: 13px;
  font-weight: 400;
  line-height: 145%;
  color: ${colors.gray.dark};
  margin: 0;
  strong {
    font-family: 'Open Sans';
  }
`
